var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{on:{"click":_vm.abrirTJ}},[_vm._v("\n  "+_vm._s(_vm.propMensalista ? _vm.propSelo.selo.num_selo : _vm.propSelo ?
    _vm.propSelo.selo.num_selo.substring(0,6) + '...' : '---')+"\n")])}
var staticRenderFns = []

export { render, staticRenderFns }